var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn bg-info text-white",attrs:{"disabled":""},on:{"click":_vm.emailContact}},[_c('i',{class:_vm.actionButtonIcon}),_vm._v("\n    "+_vm._s(_vm.callToActionButtonLabel || 'Action')+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-242d5836","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/EmailContactButton.vue
// module id = null
// module chunks = 